import { defineStore } from 'pinia'
import api from '@/utils/api'

export const usePagesStore = defineStore('pages', {
  state: () => ({
    pages: [],
    loading: false,
    error: null
  }),
  getters: {
    pageBySlug: (state) => (slug) => {
      return state.pages.find(page => page.slug === slug) || null
    },
    publicPages: (state) => {
      return state.pages.filter(page => page.slug && page.title)
    }
  },
  actions: {
    async fetchPages() {
      this.loading = true
      this.error = null
      try {
        const data = await api.get('/pages')
        this.pages = data || []
      } catch (error) {
        this.error = error.message || 'Failed to fetch pages'
        // Only clear data if we don't have any existing data
        if (this.pages.length === 0) {
          this.pages = []
        }
      } finally {
        this.loading = false
      }
    }
  }
}) 